import { useCallback, useMemo } from 'react';
import type { ObjectPaymentReportRow } from '@econtractor/types';

export const usePaymentObjectOptions = (payments: ObjectPaymentReportRow[] | null) => {
    const objects = useMemo(() => Array.from(new Map((payments || []).map((row) => [
        row.objectId,
        { ID: Number(row.objectId), objectName: row.objectName || row.clientName || `#${row.objectId}` },
    ])).values()), [payments]);
    return useCallback(async ({ search }: { search: string }) => ({
        objects: objects.filter((object) => object.objectName.toLocaleLowerCase().includes(search.toLocaleLowerCase())),
    }), [objects]);
};
